import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";


const AdsPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  // Form State
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", message: "" });

  const Skeleton = ({ style }) => (
  <div style={{ ...styles.skeleton, ...style }} />
);


const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    page_id: page.id,
    page_slug: slug,
    ...formData
  };

  const res = await fetch(
    "https://kalakakshaaha.com/kks/api/v1/ads-enquiry",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }
  );

  const data = await res.json();

if (data.success) {
  Swal.fire({
    icon: "success",
    title: "Enquiry Sent!",
    text: "Our team will contact you shortly.",
    confirmButtonColor: "#f39c12"
  });

  setFormData({ name: "", email: "", phone: "", message: "" });

} else {
  Swal.fire({
    icon: "error",
    title: "Submission Failed",
    text: data.message || "Something went wrong. Please try again.",
    confirmButtonColor: "#f39c12"
  });
}
};

const AdsSkeleton = () => {
  return (
    <div style={styles.pageWrapper}>
      <div className="container" style={styles.mainGrid}>
        
        {/* LEFT */}
        <div>
          <Skeleton style={{ height: 40, width: "60%", marginBottom: 20 }} />
          <Skeleton style={{ height: 400, borderRadius: 16, marginBottom: 30 }} />
          <Skeleton style={{ height: 20, width: "90%", marginBottom: 10 }} />
          <Skeleton style={{ height: 20, width: "85%", marginBottom: 10 }} />
          <Skeleton style={{ height: 20, width: "70%" }} />
        </div>

        {/* RIGHT */}
        <div>
          <div style={styles.formCard}>
            <Skeleton style={{ height: 30, width: "50%", marginBottom: 20 }} />
            <Skeleton style={{ height: 45, marginBottom: 15 }} />
            <Skeleton style={{ height: 45, marginBottom: 15 }} />
            <Skeleton style={{ height: 45, marginBottom: 15 }} />
            <Skeleton style={{ height: 90, marginBottom: 15 }} />
            <Skeleton style={{ height: 50 }} />
          </div>
        </div>

      </div>
    </div>
  );
};


  useEffect(() => {
    fetch(`https://kalakakshaaha.com/kks/api/v1/pages/${slug}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setPage(data.page);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [slug]);

 if (loading) return <AdsSkeleton />;

  if (!page) return <div style={styles.loader}>Page not found</div>;

  return (
    <div style={styles.pageWrapper}>
      <div className="container" style={styles.mainGrid}>
        
        {/* LEFT COLUMN: Content */}
        <div style={styles.contentSection}>
          <h1 style={styles.title}>{page.title}</h1>
          
          {page.image && (
            <div style={styles.imageContainer}>
              <img  src={`https://kalakakshaaha.com/uploads/pages/${page.image}`}alt={page.title} style={styles.heroImage} />
            </div>
          )}

          <div style={styles.textContent}>
            <p style={styles.shortDesc} dangerouslySetInnerHTML={{ __html: page.short_description }} ></p>
            <div 
              style={styles.fullBody} 
              dangerouslySetInnerHTML={{ __html: page.full_content }} 
            />
          </div>
        </div>
        

        {/* RIGHT COLUMN: Enquiry Form */}
        <div style={styles.formSidebar}>
          <div style={styles.formCard}>
            <h3 style={{ marginBottom: '20px', color: '#fff' }}>Enquire Now</h3>
          <form style={styles.form} onSubmit={handleSubmit}>

    <input
  type="text"
  placeholder="Your Name"
  style={styles.input}
  value={formData.name}
  onChange={e => setFormData({ ...formData, name: e.target.value })}
/>

<input
  type="email"
  placeholder="Email Address"
  style={styles.input}
  value={formData.email}
  onChange={e => setFormData({ ...formData, email: e.target.value })}
/>

<input
  type="tel"
  placeholder="Phone Number"
  style={styles.input}
  value={formData.phone}
  onChange={e => setFormData({ ...formData, phone: e.target.value })}
/>

<textarea
  placeholder="How can we help you?"
  rows="4"
  style={styles.input}
  value={formData.message}
  onChange={e => setFormData({ ...formData, message: e.target.value })}
/>

              <button type="submit" style={styles.submitBtn}>Send Message</button>
            </form>
           
          </div>
        </div>

      </div>
    </div>
  );
};

// Modern CSS-in-JS styles
const styles = {
pageWrapper: {
  backgroundColor: "#121212",
  minHeight: "100vh",
  color: "#fff",
  padding: "20px 15px"
}
,
mainGrid: {
  display: "grid",
  gridTemplateColumns: "1fr", // mobile-first
  gap: "30px",
  maxWidth: "1200px",
  margin: "0 auto"
}
,title: {
  fontSize: "clamp(1.6rem, 5vw, 2.5rem)",
  fontWeight: "bold",
  marginBottom: "20px"
}
,
  title: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: "20px",
    background: "linear-gradient(90deg, #fff, #aaa)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent"
  },
  imageContainer: {
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
    marginBottom: "30px"
  },
  heroImage: {
    width: "100%",
    maxHeight: "400px",
    objectFit: "cover",
    display: "block"
  },
  shortDesc: {
    fontSize: "1.2rem",
    color: "#ccc",
    lineHeight: "1.6",
    borderLeft: "4px solid #f39c12", // Accent color
    paddingLeft: "20px",
    marginBottom: "20px"
  },

  skeleton: {
  background: "linear-gradient(90deg, #222 25%, #333 37%, #222 63%)",
  backgroundSize: "400% 100%",
  animation: "shimmer 1.4s ease infinite",
  borderRadius: "8px"
}
,


  fullBody: {
    lineHeight: "1.8",
    color: "#eee"
  },
  formSidebar: {
    position: "relative"
  },
formCard: {
  position: "relative",
  background: "rgba(255, 255, 255, 0.05)",
  backdropFilter: "blur(10px)",
  padding: "25px",
  borderRadius: "16px",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  boxShadow: "0 8px 32px rgba(0,0,0,0.37)"
}
,
input: {
  width: "100%",
  boxSizing: "border-box",
  padding: "12px",
  marginBottom: "15px",
  borderRadius: "8px",
  border: "1px solid #444",
  backgroundColor: "#222",
  color: "#fff"
}
,
  submitBtn: {
    width: "100%",
    padding: "15px",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "#f39c12", // Professional gold/orange
    color: "#000",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "transform 0.2s"
  },
  formFooter: {
    fontSize: "0.8rem",
    color: "#777",
    textAlign: "center",
    marginTop: "15px"
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    color: "#fff",
    backgroundColor: "#121212"
  },

  "@media (min-width: 768px)": {
  mainGrid: {
    gridTemplateColumns: "2fr 1fr"
  }
},

"@media (min-width: 768px)": {
  formCard: {
    position: "sticky",
    top: "40px"
  }
}


};

export default AdsPage;